import API from "api/axiosInstance";
import {
  setIsLoading,
  setListPeringatan,
  setMessage,
  setStatus,
} from "./index";

export const fetchListPeringatan =
  (page = 1, limit = 25) =>
  async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get("/peringatan/get", {
        params: { page, limit },
      });
      dispatch(setIsLoading(false));
      dispatch(
        setListPeringatan({
          list: response.data.data,
          pagination: response.data.pagination,
        }),
      );
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchAddPeringatan = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const formData = new FormData();
    formData.append("judul_peringatan", reqData.judul_peringatan);
    formData.append("tanggal_berlaku", reqData.tanggal_berlaku);
    formData.append("tanggal_berakhir", reqData.tanggal_berakhir);
    formData.append("id_karyawan", reqData.id_karyawan);
    formData.append("file_peringatan", reqData.file_peringatan);

    const response = await API.post("/peringatan/add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error?.response?.data?.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDeletePeringatan = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(`/peringatan/delete/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
